import { colors } from '../../colors';
var pagination = {
  activeColor: colors.brickOrange,
  defaultColor: colors.smoke
};
export default pagination;